import { badgeDriverFactory } from '../Badge/Badge.driver';
import { popoverLegacyDriverFactory } from '../Popover/Popover.driver';
import { badgeSelectDriverFactory as badgeSelectPublicDriverFactory } from './BadgeSelect.driver';

export const badgeSelectPrivateDriverFactory = ({ element, eventTrigger }) => {
  const popoverDriver = popoverLegacyDriverFactory({ element, eventTrigger });

  const badgeDriver = badgeDriverFactory({
    element: popoverDriver.getTargetElement().childNodes[0],
    eventTrigger,
  });

  return {
    ...badgeSelectPublicDriverFactory({ element, eventTrigger }),

    /** Clicks on the element */
    click: () => element.click(),

    /** Clicks on the badge */
    clickOnBadge: () => badgeDriver.click(),

    /** Performs a click outside the component */
    clickOutside: () => popoverDriver.clickOutside(),

    /** Whether the dropdown is shown */
    isDropdownShown: () => popoverDriver.isContentElementExists(),

    /** Gets badge type */
    getType: badgeDriver.getType,

    /** Gets badge type */
    getSkin: badgeDriver.getSkin,

    /** Gets badge size */
    getSize: badgeDriver.getSize,

    /** Checks whether the text is uppercase */
    isUppercase: badgeDriver.isUppercase,
  };
};
